import { Link, useLocation } from "react-router-dom";
import React, { useEffect } from "react";

function Breadcrumb({ children }) {
  const locationPage = useLocation();
  console.log("what is pageName", locationPage.pathname);
  const path = locationPage.pathname.replace("/", "");

  const pageTitle = path
    ? path
        .split(/(?=[A-Z])|-/)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "Home";

  useEffect(() => {
    document.title = `St. Joseph’s school, Barhalganj | ${pageTitle}`;
  }, [pageTitle]);

  return (
    <div className="innerslide py-3 bg-light border-bottom">
      <nav aria-label="breadcrumb">
        <ul className="breadcrumb container mb-0 align-items-center">
          <li className="breadcrumb-item">
            <Link to="/" className="text-decoration-none">
              <i className="bi bi-house-door me-1"></i> Home
            </Link>
          </li>
          {React.Children.map(children, (child) => (
            <li className="breadcrumb-item active">{child}</li>
          ))}
        </ul>
      </nav>
    </div>
  );
}

export default Breadcrumb;
